<template>
	<div class="content__column content__column--small" v-if="product">
		<h1 class="content__title">Editar Producto</h1>
		<form class="form" @submit.prevent="saveProduct">
			<div class="fom__fieldset">
				<div class="form__container">
					<label for="title_es" class="form__label form__label--required">Título del producto (ES)</label>
					<input type="text" class="form__input" name="title_es" id="title_es" v-model="product.title_es" v-validate="validation.title_es" />
					<span v-show="errors.has('title_es')" class="form__alert" v-text="errors.first('title_es')"></span>
				</div>

				<div class="form__container">
					<label for="title_en" class="form__label form__label--required">Título del producto (EN)</label>
					<input type="text" class="form__input" name="title_en" id="title_en" v-model="product.title_en" v-validate="validation.title_en" />
					<span v-show="errors.has('title_en')" class="form__alert" v-text="errors.first('title_en')"></span>
				</div>

				<div class="form__container">
					<label for="description_es" class="form__label">Descripción del producto (ES)</label>
					<ckeditor :config="ckeconfig" class="form__input" name="description_es" id="description_es" v-model="product.description_es" v-validate="validation.description_es"></ckeditor>
					<span v-show="errors.has('description_es')" class="form__alert" v-text="errors.first('description_es')"></span>
				</div>

				<div class="form__container">
					<label for="description_en" class="form__label">Descripción del producto (EN)</label>
					<ckeditor :config="ckeconfig" class="form__input" name="description_en" id="description_en" v-model="product.description_en" v-validate="validation.description_en"></ckeditor>
					<span v-show="errors.has('description_en')" class="form__alert" v-text="errors.first('description_en')"></span>
				</div>

				<div class="form__container">
					<label for="details_es" class="form__label">Detalles del producto (ES)</label>
					<ckeditor :config="ckeconfig" class="form__input" name="details_es" id="details_es" v-model="product.details_es" v-validate="validation.details_es"></ckeditor>
					<span v-show="errors.has('details_es')" class="form__alert" v-text="errors.first('details_es')"></span>
				</div>

				<div class="form__container">
					<label for="details_en" class="form__label">Detalles del producto (EN)</label>
					<ckeditor :config="ckeconfig" class="form__input" name="details_en" id="details_en" v-model="product.details_en" v-validate="validation.details_en"></ckeditor>
					<span v-show="errors.has('details_en')" class="form__alert" v-text="errors.first('details_en')"></span>
				</div>

				<div class="form__container">
					<label for="weight" class="form__label form__label--required">Peso (Kg)</label>
					<input type="text" class="form__input" name="weight" id="weight" v-model="product.weight" v-validate="validation.weight" />
					<span v-show="errors.has('weight')" class="form__alert" v-text="errors.first('weight')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="parent_id"> Categoría principal</label>
					<div class="form__select-container">
						<select name="parent_id" id="parent_id" class="form__select" v-validate="validation.parent_id" v-model="product.parent_id">
							<option hidden :value="null">Seleccione una categoría</option>
							<template v-for="(category, index) in categories">
								<option v-if="!category.parent_id" :key="index" :value="category.id" v-text="category.title_es"></option>
							</template>
						</select>
					</div>
					<span v-show="errors.has('parent_id')" class="form__alert" v-text="errors.first('parent_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="category_id"> Categoría</label>
					<div class="form__select-container" v-if="product.parent_id">
						<select name="category_id" id="category_id" class="form__select" v-validate="validation.category_id" v-model="product.category_id">
							<option hidden :value="null">Seleccione una categoría</option>
							<template v-for="(category, index) in categories">
								<option v-if="category.parent_id && category.parent_id === product.parent_id" :key="index" :value="category.id" v-text="category.title_es"></option>
							</template>
						</select>
					</div>
					<span v-show="errors.has('category_id')" class="form__alert" v-text="errors.first('category_id')"></span>
				</div>

				<div class="form__container">
					<label for="price" class="form__label">Precio</label>
					<input type="text" class="form__input" name="price" id="price" v-model="product.price" v-validate="validation.price" placeholder="Ej. 2345.50" />
					<span v-show="errors.has('price')" class="form__alert" v-text="errors.first('price')"></span>
				</div>

				<div class="form__container">
					<label for="dtypes" class="form__label">Tipos de descuentos</label>
					<div class="form__radio-container">
						<input class="form__radio form__radio--circular" type="radio" name="discount_type" id="nodiscount" :value="null" v-model="product.discount_type_id" />
						<label class="form__label" for="nodiscount"> <span class="form__selector form__selector--circular"></span> Sin descuento </label>
					</div>
					<div class="form__radio-container" v-for="(type, index) in discountTypes" :key="index">
						<input class="form__radio form__radio--circular" type="radio" name="discount_type" :id="type.name" :value="type.id" v-model="product.discount_type_id" />
						<label class="form__label" :for="type.name">
							<span class="form__selector form__selector--circular"></span>
							{{ type.name }}
						</label>
					</div>
				</div>

				<div class="form__container" v-if="product.discount_type_id">
					<label for="discount" class="form__label">Descuento</label>
					<input type="text" class="form__input" name="discount" id="discount" v-model="product.discount" v-validate="validation.discount" placeholder="Ej. 10.24" />
					<span v-show="errors.has('discount')" class="form__alert" v-text="errors.first('discount')"></span>
				</div>

				<div class="form__container">
					<label class="form__label" for="designer_id">Diseñador</label>
					<div class="form__select-container form__label--required">
						<select name="designer_id" id="designer_id" class="form__select" v-validate="validation.designer_id" v-model="product.designer_id">
							<option hidden :value="null">Seleccione un diseñador</option>
							<option v-for="(designer, index) in designers" :key="index" :value="designer.id" v-text="designer.name"></option>
						</select>
					</div>
					<span v-show="errors.has('designer_id')" class="form__alert" v-text="errors.first('designer_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="status_id"> Estatus del Producto</label>
					<div class="form__select-container">
						<select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="product.status_id">
							<option hidden :value="null">Seleccione un estatus</option>
							<option v-for="(status, index) in product_status" :key="index" :value="status.id" v-text="status.name"></option>
						</select>
					</div>
					<span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
				</div>
			</div>
			<input type="submit" class="btn btn__action btn--regular" value="Guardar" />
			<button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">
				Agregar Nuevo Producto
			</button>
		</form>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import { product_status } from './mocks'
	import { config } from '@/core/config/base'
	import Mixins from './mixins'
	import { ckeconfig } from '@/core/config/ckeditor'
	import CKEditor from 'ckeditor4-vue'
	export default {
		components: {
			ckeditor: CKEditor.component
		},
		props: {
			product: {
				type: Object,
				required: false,
				default: function() {
					return {
						id: null,
						title_es: null,
						title_en: null,
						weight: 0.0,
						price: 0.0,
						status_id: null,
						designer_id: null,
						discount: null,
						discount_type: null,
						category_id: null,
						description_en: null,
						description_es: null,
						details_en: null,
						details_es: null
					}
				}
			}
		},
		mixins: [httpService, Mixins],
		data: function() {
			return {
				ckeconfig: ckeconfig,
				product_status: product_status,
				validation: {
					title_es: 'required|max:100',
					title_en: 'required|max:100',
					weight: 'required|decimal|min_value:0.0001',
					status_id: 'required|min_value:1|max:4',
					designer_id: 'min_value:1|max:11|numeric',
					price: 'decimal',
					discount: 'decimal',
					discount_type: 'numeric|min_value:1|max:11',
					category_id: 'numeric|min_value:1|max:11'
				}
			}
		},
		created: function() {
			this.getDesigners()
			this.getDiscountTypes()
			this.getCategories()
		},
		methods: {
			saveProduct: function() {
				this.$validator.validateAll().then(result => {
					if (result) {
						let httpRequest = {
							params: '',
							module: 'products',
							element: this.product
						}
						let action
						if (this.product.id) {
							action = this.put(this.product.id, httpRequest)
						} else {
							action = this.post(httpRequest)
						}
						action
							.then(response => {
								if (!this.product.id) {
									this.product.id = response.data.current_id
								}
								this.$store.commit('elementChanged', {
									module: 'productEdit',
									time: Math.round(new Date().getTime() / 1000)
								})
								this.$store.commit('notificate', {
									title: 'PRODUCTO GUARDADO',
									text: 'El producto ha sido guardado correctamente',
									type: 'success'
								})
							})
							.catch(() => {
								this.$store.commit('notificate', {
									title: 'PRODUCTO NO GUARDADO',
									text: 'El producto no ha sido guardado, por favor, intente más tarde',
									type: 'error'
								})
							})
					}
				})
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/edit.vue